import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/es5/util/colors'
import de from 'vuetify/es5/locale/de'
import en from 'vuetify/es5/locale/en'
import fr from 'vuetify/es5/locale/fr'
import es from 'vuetify/es5/locale/es'
import it from 'vuetify/es5/locale/it'
import VueGridLayout from 'vue-grid-layout'
import moment from 'moment'
import swal from 'sweetalert2'
import VueTimers from 'vue-timers'
import sanitizeHtml from 'sanitize-html'
import VueCookies from 'vue-cookies'
import { VLazyImagePlugin } from 'v-lazy-image'
import Clipboard from 'v-clipboard'

import App from './App'
import store from './store'
import router from './router'

import http from './plugins/http'
import i18n from './plugins/i18n'
import helper from './plugins/helper'
import webrptapi from './plugins/webrptapi'
import validation from './plugins/validation'

import Loader from '@/client/components/Loader'
import ContentNotAvailable from '@/client/components/Dashboard/ContentNotAvailable'

import 'vuetify/dist/vuetify.css'
import 'font-awesome/css/font-awesome.css'
import 'weather-icons/css/weather-icons.css'
import 'material-design-icons/iconfont/material-icons.css'
import 'flag-icon-css/css/flag-icon.css'

const EventBus = new Vue()

Vue.prototype.$environment = process.env.NODE_ENV || 'development'
Vue.prototype.$VENDOR = process.env.VENDOR
Vue.prototype.$HOST = process.env.ROOT_HOST_PORT
Vue.prototype.$EventBus = EventBus
Vue.prototype.$moment = moment
Vue.prototype.$swal = swal
Vue.prototype.$sanitize = sanitizeHtml

Vue.config.productionTip = false
Vue.config.performance = false
Vue.config.devtools = Vue.prototype.$environment === 'development'

Vue.component('vbus-loading', Loader)
Vue.component('content-not-available', ContentNotAvailable)

Vue.directive('highlight', function (el, binding) {
  if (binding.value % 2 !== 0) {
    el.className += ' highlight-entry'
  }
})

Vue.use({
  install (V) {
    let bus = new Vue()
    V.prototype.$bus = bus
    V.bus = bus
  }
})

Vue.use(VueCookies)
Vue.$cookies.config('30d')

let lng = Vue.$cookies.get('VBus.net-I18N')
const fallBack = 'de'
const languages = ['de', 'en', 'fr', 'es', 'it']
const vendor = process.env.VENDOR

if (!lng) {
  if (window.localStorage) {
    lng = localStorage.getItem('lng')
  }
}

if (lng && typeof lng === 'string') {
  const l = lng.toLocaleLowerCase()
  if (languages.indexOf(l) !== -1) {
    lng = l
  } else {
    lng = fallBack
  }
} else {
  lng = fallBack
}
if (vendor === 'mtf') {
  lng = 'de'
}

store.commit('setLng', lng)

const themeByVendor = {
  resol: {
    primary: '#3fa535',
    info: colors.blue.lighten3,
    resolGreen: '#007749',
    resolError: '#bf1d1d',
    resolSuccess: '#55b75b'
  },
  mtf: {
    primary: '#1428A0',
    info: colors.blue.lighten3,
    resolGreen: '#1428A0',
    resolError: '#bf1d1d',
    resolSuccess: '#55b75b'
  }
}

Vue.use(Vuetify, {
  lang: {
    current: lng,
    locales: {de, en, fr, es, it}
  },
  theme: themeByVendor[vendor]
})

Vue.use(VueTimers)
Vue.use(VueGridLayout)
Vue.use(http)
Vue.use(helper)
Vue.use(webrptapi)
Vue.use(validation)
Vue.use(VLazyImagePlugin)
Vue.use(Clipboard)

http.readConfiguration().then(configurations => {
  store.commit('setConfiguration', configurations)
  http.readSession().then(() => {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      store,
      router,
      i18n,
      template: '<App/>',
      components: { App },
      mounted () {
        this.$i18n.i18next.changeLanguage(lng)
        this.$vuetify.lang.current = lng
      }
    })
  }).catch(ex => {
    console.log('http.readSession()', ex)
  })
}).catch(ex => {
  console.log('http.readConfiguration()', ex)
})



// WEBPACK FOOTER //
// ./src/main.js